import {Element, Editor} from "../../../../../../pkg/slate.js";
export const matchElement = (type) => (node) => {
  if (Editor.isEditor(node) || !Element.isElement(node))
    return false;
  if (Array.isArray(type)) {
    return type.includes(node.type);
  }
  return node.type === type;
};
